var map = {
	"./assets/backIconLeft2.png": "11a7",
	"./assets/backIconRight2.png": "487a",
	"./assets/check-circle-fill2.png": "e45d",
	"./assets/comment2.png": "d8d3",
	"./assets/gzImg/icon_portrait_report_image_2.png": "cbf5",
	"./assets/gzImg/rep_green2.png": "44d2",
	"./assets/icon_ai_report_icon_2.png": "b9fe",
	"./assets/icon_ai_search_icon_2.png": "68ff",
	"./assets/icon_clock2.png": "860e",
	"./assets/icon_common_select_date_icon_2.png": "dd15",
	"./assets/icon_common_special_arrow_12.png": "f8ae",
	"./assets/icon_common_special_arrow_2.png": "a71c",
	"./assets/icon_dean_home_alert_bg_2.png": "8c2f",
	"./assets/icon_dean_home_alert_icon_12.png": "9b86",
	"./assets/icon_dean_home_alert_icon_2.png": "2273",
	"./assets/icon_dean_home_bg_card_2.png": "dc68",
	"./assets/icon_dean_home_bg_card_icon_12.png": "343e",
	"./assets/icon_dean_home_bg_card_icon_2.png": "324b",
	"./assets/icon_dean_home_card_empty_icon_2.png": "d0f5",
	"./assets/icon_dean_home_card_measure_2.png": "4102",
	"./assets/icon_dean_old_healthy_icon_2.png": "eec3",
	"./assets/icon_health_data_search_input_icon_2.png": "dbdc",
	"./assets/icon_home_ai_icon_12.png": "e297",
	"./assets/icon_home_ai_icon_2.png": "eb27",
	"./assets/icon_home_ai_icon_3_2.png": "633c",
	"./assets/icon_home_hei_san_jiao_2.png": "f451",
	"./assets/icon_home_new_icon_bg_2.png": "a733",
	"./assets/icon_home_new_icon_dou_hao_2.png": "c481",
	"./assets/icon_home_new_icon_fanwei_2.png": "d2fd",
	"./assets/icon_home_new_icon_san_jiao_2.png": "0cb5",
	"./assets/icon_portrait_arrow_2.png": "d31f",
	"./assets/icon_report_empty_logo_2.png": "13b9",
	"./assets/icon_sos_btn_bell_2.png": "eec2",
	"./assets/icon_work_proposal_icon_12.png": "3d5b",
	"./assets/icon_work_proposal_icon_2.png": "d02e",
	"./assets/report_detail_icon_down_h@2x2.png": "519e",
	"./assets/sjAfter2.png": "d631",
	"./assets/static/back2.png": "e448",
	"./assets/static/c2.png": "5beb",
	"./assets/static/comment2.png": "86af",
	"./assets/static/hxsd_img2.png": "0064",
	"./assets/static/icon_falldown2.png": "6d44",
	"./assets/static/wifi2.png": "b4b4",
	"./assets/szhxNo2.png": "5603",
	"./assets/szhxNo3_2.png": "285c",
	"./assets/szhx_titIcon2.png": "fb40",
	"./assets/tableIcon2.png": "ac04",
	"./assets/tan_bjSingle2.png": "e5d2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3afd";